<template>
<div class="container-fluid">
	<notification-toolbar heading="Notification Settings"></notification-toolbar>

	<form class="container">
		<p>You can toggle on/off which notifications you'd like to receive</p>

		<div class="row">

			<div v-for="(sectionLabel,moduleKey) in sections" v-if="hasModulePermRead(moduleKey) || permExceptions.indexOf(moduleKey) >= 0" class="col-lg-6">
				<hr>
				<h3>{{sectionLabel}}</h3>

				<field v-for="(label,event) in filterEventsToModule(moduleKey)" 
					:key="event"
					:label="label"
					col-class="col-auto"
					:control-left="true"
					v-model="payload[event]"
					:params="{type:'boolean'}"
					v-on:change="updateSetting($event,event)">
				</field>

			</div>
		</div>
	</form>
</div>
</template>
<script type="text/javascript">
import NotificationToolbar from  "@/pages/notifications/NotificationToolbar"
import Field from "@/components/Field"

export default {
	name: "NotificationSettings",
	components: {
		NotificationToolbar,
		Field
	},
	data() {
		return {
			eventList: {},
			sections: {
				Jobs: "Project Notifications",
				Services: "Service Notifications",
				ServiceContracts: "Service Contracts",
				Locates: "Locates Notifications",
				Certificates: "Training Certificate Notifications",
				Equipment: "Equipment Notifications",
				Users: "Employee Notifications",
				Library: "Library Notifications",
				CompensationSchedule: "Compensation Schedule",
				CompanyForms: "Company Forms"
			},
			payload: {},
			permExceptions: ["Library","Certificates","Jobs","Services"]
		}
	},
	computed: {

	},
	methods: {
		filterEventsToModule(module_key) {
			let vm = this

			let keys = Object.keys(this.eventList).filter(event => {
				if (event.search(module_key) >= 0)
					return true
			})

			let events = {}

			keys.forEach(key => {
				events[key] = vm.eventList[key]
			})

			return events
		},
		updateSetting(value,event) {
			let vm = this

			this.$nextTick(() => {
				let payload = {
					user_id: this.$store.userDetails.id,
					notifications_json: JSON.stringify(this.payload)
				}

				this.postData("EmployeeSetting/save",payload,true).then(response => {
					if (response.success)
						vm.alertSaved("Notification settings updated")
				})
			})
		},
		fetchNotificationEvents() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("Notification/list-events").then(response => {
					if (response.success) {
						vm.eventList = response.data
					}
					resolve(response)
				})
			})
		},
		fetchUserNotificationSettings() {
			let vm = this


			return new Promise((resolve,reject) => {
				vm.getJSON("EmployeeSetting/mine").then(response => {
					if (response.success) {
						try {
							vm.payload = JSON.parse(response.data.notifications_json)
						}
						catch (e) {
							vm.payload = {}
						}

						//if no value for event, toggle it as on
						Object.keys(vm.eventList).forEach(event => {
							if (!(event in vm.payload))
								vm.payload[event] = true
						})
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.fetchNotificationEvents(),
				this.fetchUserNotificationSettings()
			]

			this.spinner(true)

			Promise.all(promises).then(response => {
				vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>